import { FC, memo, useEffect } from 'react';
import { IconWrapper } from 'shared/assets/styles';
import { FlexBox, FInter, HintTooltip } from '@brg/ui';
import styled, { useTheme } from 'styled-components';
import { ViewAPI, ViewObject } from '@brg/api';
import { LayoutConst } from 'core/modules/layout.module';
import { useFingerprintId } from "@brg/auth";
import { useTranslation } from 'react-i18next';
import { ViewsIcon } from "../../icons/projectToolsWithResize/ViewsIcon";
import { useDispatch, useSelector } from "react-redux";
import { CurrentProjectActions, CurrentProjectSelector } from "../../reducers/CurrentProject";
import { getTooltipStyles, tooptipStylesWhite } from 'shared/constants/tooptipStyles';
import { AppTester } from 'supporting';
import { ToolBarItemWrapper } from 'shared/pages/project/components/ProjectButtons';

const ALLOWED_COUNT = 1000;

const ViewCountText = styled(FInter.SmallText)`
  font-size: 13px;
  line-height: 16px;
  color: ${(p) => p.theme.icon.default};
  font-weight: 400;

  &:not(:first-child) {
    margin-left: 0;
  }

  margin-top: 4px;
  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    font-size: 11px;
    line-height: 13px;
  }
  
  @media (max-width: 940px) {
    margin-top: 0;
    &:not(:first-child) {
      margin-left: 8px;
    }
  }
`;



type PropsT = {
  entityType: string;
  entityId: string;
  disabled?: boolean;
  toolTipProps?: any;
};

const ViewCount: FC<PropsT> = ({ entityId, entityType, disabled, toolTipProps }) => {
  const theme = useTheme();
  const viewCount = useSelector(CurrentProjectSelector)?.likes?.[entityId]?.views || 0;
  const fingerprintId = useFingerprintId();
  const { t } = useTranslation();
  const isGeo = AppTester.isGeograffee();
  const isSuperPuper = AppTester.isSuperPuper();
  const isGeoDafes = AppTester.isGeoDafes();
  const onWhiteBg = !isGeo && !isSuperPuper;
  const dispatch = useDispatch();

  useEffect(() => {

    // обязательно должен быть фингерпринт, чтобы запрос обработался(сам он находится в заголовках)
    if (!fingerprintId || disabled) return;

    ViewAPI.UpdateView({ entityId, entityType })
      .then((e) => e.json())
      .then((e: ViewObject) => {
        dispatch(CurrentProjectActions.setLikesField({id: entityId, field: 'views', value: e.count }))
      })
      .catch(() => {
        
      })
  }, [entityId, entityType, fingerprintId, disabled]);

  if (viewCount < ALLOWED_COUNT) {
    return null
  }

  return (
    <ToolBarItemWrapper className="ViewsCountWrapper ps-action-btn">
      <IconWrapper hoverDisabled >
        <FlexBox
          align={'center'}
          justify={"flex-start"}
          direction={'column'}
          directionMobile={'row'}
          offsetBottomMobile={0}
          className={'count-icon-wrapper'}
        >
          <HintTooltip customStyle={isGeoDafes || onWhiteBg ? tooptipStylesWhite : getTooltipStyles(theme)} text={t("hints.views")} z={5} noDisappearDelay onWhiteBg={onWhiteBg} {...toolTipProps}>
            <ViewsIcon />
          </HintTooltip>
          <ViewCountText
            className={'view-count-text'}
            color={theme.viewCount.text}>
            {viewCount}
          </ViewCountText>
        </FlexBox>
      </IconWrapper>
    </ToolBarItemWrapper>
  )
};

export default memo(ViewCount)

import { FC, memo, useEffect } from 'react';
import { IconWrapper } from 'shared/assets/styles';
import { FlexBox, FInter, HintTooltip } from '@brg/ui';
import styled, { useTheme } from 'styled-components';
import { ViewAPI, ViewObject } from '@brg/api';
import { LayoutConst } from 'core/modules/layout.module';
import { useFingerprintId } from "@brg/auth";
import { useTranslation } from 'react-i18next';
import { ViewsIcon } from "../../icons/projectToolsWithResize/ViewsIcon";
import { useDispatch, useSelector } from "react-redux";
import { CurrentProjectActions, CurrentProjectSelector } from "../../reducers/CurrentProject";
import { getTooltipStyles, tooptipStylesWhite } from 'shared/constants/tooptipStyles';
import { AppTester } from 'supporting';
import { ToolBarItemWrapper } from 'shared/pages/project/components/ProjectButtons';

const ALLOWED_COUNT = 1000;

const ViewCountText = styled(FInter.SmallText)`
  font-size: 13px;
  line-height: 16px;
  color: ${(p) => p.theme.icon.default};
  font-weight: 400;

  &:not(:first-child) {
    margin-left: 0;
  }

  margin-top: 4px;
  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    font-size: 11px;
    line-height: 13px;
  }
  
  @media (max-width: 940px) {
    margin-top: 0;
    &:not(:first-child) {
      margin-left: 8px;
    }
  }
`;



type PropsT = {
  entityType: string;
  entityId: string;
  disabled?: boolean;
  toolTipProps?: any;
};

const ViewCount: FC<PropsT> = ({ entityId, entityType, disabled, toolTipProps }) => {
  const theme = useTheme();
  const viewCount = useSelector(CurrentProjectSelector)?.likes?.[entityId]?.views || 0;
  const fingerprintId = useFingerprintId();
  const { t } = useTranslation();
  const isGeo = AppTester.isGeograffee();
  const isSuperPuper = AppTester.isSuperPuper();
  const isGeoDafes = AppTester.isGeoDafes();
  const onWhiteBg = !isGeo && !isSuperPuper;
  const dispatch = useDispatch();

  useEffect(() => {

    // обязательно должен быть фингерпринт, чтобы запрос обработался(сам он находится в заголовках)
    if (!fingerprintId || disabled) return;

    ViewAPI.UpdateView({ entityId, entityType })
      .then((e) => e.json())
      .then((e: ViewObject) => {
        dispatch(CurrentProjectActions.setLikesField({id: entityId, field: 'views', value: e.count }))
      })
      .catch(() => {
        
      })
  }, [entityId, entityType, fingerprintId, disabled]);

  if (viewCount < ALLOWED_COUNT) {
    return null
  }

  return (
    <ToolBarItemWrapper className="ViewsCountWrapper ps-action-btn">
      <IconWrapper hoverDisabled >
        <FlexBox
          align={'center'}
          justify={"flex-start"}
          direction={'column'}
          directionMobile={'row'}
          offsetBottomMobile={0}
          className={'count-icon-wrapper'}
        >
          <HintTooltip customStyle={isGeoDafes || onWhiteBg ? tooptipStylesWhite : getTooltipStyles(theme)} text={t("hints.views")} z={5} noDisappearDelay onWhiteBg={onWhiteBg} {...toolTipProps}>
            <ViewsIcon />
          </HintTooltip>
          <ViewCountText
            className={'view-count-text'}
            color={theme.viewCount.text}>
            {viewCount}
          </ViewCountText>
        </FlexBox>
      </IconWrapper>
    </ToolBarItemWrapper>
  )
};

export default memo(ViewCount)

